module.exports = __webpack_public_path__ + "img/11.bfe61dea.png";